import {Anchor, Button, Dialogue, Icon, Modal, Text} from '@albert-io/atomic';
import React, {useState} from 'react';

import constants from 'client/constants';

export const COPYRIGHT_TEXT = `Copyright ${new Date().getFullYear()} Learn By Doing, Inc.`;

interface CopyrightModalContentProps {
  onClose: () => void;
}

export const CopyrightModalContent = ({onClose}: CopyrightModalContentProps) => (
  <Modal ariaLabel='Copyright information for Albert.io' handleClose={onClose}>
    {({CloseButtonWrapper, modalContentStyle}) => {
      return (
        <Dialogue inModal hideCloseBtn paddingLevel={4} className={modalContentStyle}>
          <Dialogue.Body className='flex flex-col items-start gap-x5'>
            <Icon icon={['fal', 'info-circle']} className='fa-2x' color='tertiary' />
            <Text bold>{COPYRIGHT_TEXT}</Text>
            <Text as='p' size='m'>
              {constants.FULL_DISCLAIMER}
            </Text>
            <Text as='p' size='m' color='tertiary'>
              <Anchor href='/privacy' className='content-secondary'>
                Privacy Policy
              </Anchor>
              <Anchor href='/terms-of-use' className='ml-x2 content-secondary'>
                Terms of Use
              </Anchor>
            </Text>
            <CloseButtonWrapper>
              <Button variant='outlined' color='secondary' onClick={onClose} className='w-full'>
                Dismiss
              </Button>
            </CloseButtonWrapper>
          </Dialogue.Body>
        </Dialogue>
      );
    }}
  </Modal>
);

const CopyrightModal = () => {
  const [showCopyrightModal, setShowCopyrightModal] = useState(false);

  return (
    <>
      <Button
        size='s'
        roundness='pill'
        onClick={() => setShowCopyrightModal(true)}
        color='secondary'
        variant='text'
        className='mx-auto my-x5 !block'
      >
        <Text className='font-normal' size='s' color='tertiary'>
          {COPYRIGHT_TEXT} <Icon icon={['far', 'info-circle']} className='ml-x0-half' />
        </Text>
      </Button>
      {showCopyrightModal && <CopyrightModalContent onClose={() => setShowCopyrightModal(false)} />}
    </>
  );
};

export default CopyrightModal;
